"use client";

import { Button } from "@/components/shadcn/button";
import { Card, CardContent, CardDescription } from "@/components/shadcn/card";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/shadcn/dialog";
import { ScrollArea } from "@/components/shadcn/scroll-area";
import { useTranslations } from "next-intl";

type VideoDetailDescriptionProps = {
    title: string;
    descriptionHtml: string;
};

export function VideoDetailDescription({
    title,
    descriptionHtml,
}: VideoDetailDescriptionProps) {
    const t = useTranslations("series");

    return (
        <Card>
            <CardContent className="flex flex-col gap-4">
                <CardDescription
                    className="line-clamp-3"
                    dangerouslySetInnerHTML={{
                        __html: descriptionHtml,
                    }}
                />
                <Dialog>
                    <DialogTrigger asChild>
                        <Button variant="link" size="xs" className="self-start">
                            {t("showMore")}
                        </Button>
                    </DialogTrigger>
                    <DialogContent className="sm:max-w-2xl">
                        <DialogHeader>
                            <DialogTitle>{title}</DialogTitle>
                            <DialogDescription className="sr-only">
                                {t("videoDescriptionFull")}
                            </DialogDescription>
                        </DialogHeader>
                        <ScrollArea className="max-h-[60vh] pr-4">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: descriptionHtml,
                                }}
                            />
                        </ScrollArea>
                    </DialogContent>
                </Dialog>
            </CardContent>
        </Card>
    );
}
